
export default {

    setHabilitations (state, habilitations) {
      state.all = habilitations
    }
}